// Formatos y estados de la asistencia por división ("Modo colegio").

export const ESTADOS_ASISTENCIA = {
  pendiente: { label: 'Pendiente', tone: 'muted' },
  presente: { label: 'Presente', tone: 'success' },
  tarde: { label: 'Tarde', tone: 'warning' },
  ausente: { label: 'Ausente', tone: 'danger' },
  justificado: { label: 'Justificado', tone: 'info' }
};

export const ESTADOS_EDITABLES = ['presente', 'tarde', 'ausente', 'justificado'];

export const getEstadoAsistencia = (estado) => ESTADOS_ASISTENCIA[estado] || ESTADOS_ASISTENCIA.pendiente;

const pick = (source, lower, upper) => source?.[lower] ?? source?.[upper];

export const normalizeAsistencia = (item) => ({
  id: String(pick(item, 'id', 'Id') || ''),
  idDivision: String(pick(item, 'idDivision', 'IdDivision') || ''),
  divisionNombre: pick(item, 'divisionNombre', 'DivisionNombre') || 'División',
  titulo: pick(item, 'titulo', 'Titulo') || '',
  codigo: pick(item, 'codigo', 'Codigo') || '',
  inicioUtc: pick(item, 'inicioUtc', 'InicioUtc') || '',
  venceUtc: pick(item, 'venceUtc', 'VenceUtc') || '',
  cerradaUtc: pick(item, 'cerradaUtc', 'CerradaUtc') || '',
  abierta: Boolean(pick(item, 'abierta', 'Abierta')),
  creadaPor: pick(item, 'creadaPor', 'CreadaPor') || '',
  total: Number(pick(item, 'total', 'Total') || 0),
  presentes: Number(pick(item, 'presentes', 'Presentes') || 0),
  tardes: Number(pick(item, 'tardes', 'Tardes') || 0),
  ausentes: Number(pick(item, 'ausentes', 'Ausentes') || 0),
  justificados: Number(pick(item, 'justificados', 'Justificados') || 0),
  pendientes: Number(pick(item, 'pendientes', 'Pendientes') || 0),
  // Vista del alumno.
  estado: pick(item, 'estado', 'Estado') || '',
  fechaRegistroUtc: pick(item, 'fechaRegistroUtc', 'FechaRegistroUtc') || ''
});

export const formatFechaHoraUtc = (value) => {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleString('es-AR', { weekday: 'short', day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' });
};

// "4:05" restantes hasta vence (o "0:00").
export const formatRestante = (venceUtc, now = Date.now()) => {
  const ms = Math.max(0, new Date(venceUtc).getTime() - now);
  const totalSeconds = Math.floor(ms / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes}:${String(seconds).padStart(2, '0')}`;
};

// Solo para tomas cerradas: mientras está abierta todavía hay pendientes.
export const porcentajeAsistencia = (asistencia) => {
  if (asistencia.abierta) return null;
  const cerrados = asistencia.total - asistencia.pendientes;
  if (cerrados <= 0) return null;
  return Math.round(((asistencia.presentes + asistencia.tardes) * 100) / cerrados);
};
